import { Box, Container } from "@mui/material";
import React from "react";

const ShutDownPage = () => {
  return (
    <Container maxWidth="xl">
      <Box className="dashboard_frame" >
        <div style={{textAlign:'center'}}>
          <h1>Shut Down Web App</h1>
        </div>
      </Box>
    </Container>
  );
};

export default ShutDownPage;
